import DiamondIcon from "@mui/icons-material/Diamond";
import { Chip, Stack, type SxProps, Typography } from "@mui/material";

interface GemsChipProps {
  completed?: boolean;
  amount: number;
  sx?: SxProps;
}

export const GemsChip = ({ completed, amount, sx }: GemsChipProps) => {
  const formattedAmount = amount >= 0 ? `+ ${amount}` : `- ${-amount}`;

  return (
    <Chip
      size="small"
      label={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="body2">{formattedAmount}</Typography>
          <DiamondIcon sx={{ fontSize: 14 }} />
        </Stack>
      }
      color={completed ? "success" : "default"}
      sx={sx}
    />
  );
};
